import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { getTranslatedObject } from '../utils/translation.util';

@Pipe({
    name: 'translateObject',
    standalone: true
})
export class TranslateObjectPipe implements PipeTransform {
    constructor(public translateService: TranslateService){}

    transform<T>(object: T[]): T {
        return getTranslatedObject(object, this.translateService.currentLang);
    }
}
